"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import type { ReactNode } from "react";
import { useReader } from "@/components/magazine/reader-context";
import { isPreviewArticlePath } from "@/lib/articles/preview-issues";
import { canReadMagazine } from "@/lib/route-policy";
export function useIsPreview() {
  const $ = _c(3);
  const reader = useReader();
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname || $[1] !== reader) {
    t0 = isPreviewArticlePath(pathname) && !(reader && canReadMagazine(reader));
    $[0] = pathname;
    $[1] = reader;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
export function HideInPreview(t0) {
  const {
    children
  } = t0;
  const isPreview = useIsPreview();
  if (isPreview) {
    return null;
  }
  return children;
}
export function ShowInPreview(t0) {
  const {
    children
  } = t0;
  const isPreview = useIsPreview();
  if (!isPreview) {
    return null;
  }
  return children;
}